import { z } from 'zod';

export const HREF_TARGET_SCHEMA = z.union([
    z.literal('_blank'),
    z.literal('_self'),
]);
export type HRefTarget = z.infer<typeof HREF_TARGET_SCHEMA>;
